import { Injectable } from "@angular/core";
import { UserService } from "./user.service";
import { TradableListService } from "./currency/tradable_list.service";
import { ModalService } from "@core-services/modal.service";

@Injectable({
	providedIn: "root"
})
export class StockTestService {
	private submitted: boolean = false;
	private isTestOpen: boolean = false;

	public constructor(
		private userService: UserService,
		private modalService: ModalService,
		private tradableListService: TradableListService
	) {}

	public needsTest(tradableId: string): boolean {
		return false;

		/**
		 * TODO: remove comment below after QA is through
		 * EATR-931: remove user session appr test check as it will triggered only via
		 * - by default always return as false
		 * - appr test is check from error /trade/prices/default and /swap/prices/default end point only
		 * - remove comment below once all QA is done
		 */

		// const tradable = this.tradableListService.getItemById(tradableId);

		// if (
		// 	tradable?.isDerivative() ||
		// 	tradable?.getCurrencyType() === TRADABLES_TYPE.LEVERAGED_TOKEN ||
		// 	tradable?.getCurrencyType() === TRADABLES_TYPE.FIAT_EARN
		// ) {
		// 	return this.userNeedsTest();
		// }
		// return false;
	}

	/**
	 * used to check in general if the user has taken the appro-test
	 */
	public userNeedsTest(): boolean {
		return this.userService.user.needsStockTest() && !this.submitted;
	}

	public getIsOpen(): boolean {
		return this.isTestOpen;
	}

	public setTestOpen(b: boolean): void {
		this.isTestOpen = b;
	}

	public setSubmitted(b: boolean): void {
		this.submitted = b;
	}

	public isSubmitted(): boolean {
		return this.submitted;
	}
}
